module.exports = __webpack_public_path__ + "static/media/suffolkpunch.5ea2cee4.ttf";